import { DEFAULT_HOST_IMAGE, getHostImageSrc } from './hostImages';

const GAME_PACK_IMAGE_DIRECTORY = '/images/game-packs';
const SAFE_GAME_PACK_IMAGE_FILENAME = /^[A-Za-z0-9][A-Za-z0-9._-]*$/;

export function getGamePackImageSrc(imageFilename, hostImageFilename) {
  if (typeof imageFilename === 'string') {
    const trimmedFilename = imageFilename.trim();

    if (trimmedFilename && SAFE_GAME_PACK_IMAGE_FILENAME.test(trimmedFilename)) {
      return `${GAME_PACK_IMAGE_DIRECTORY}/${trimmedFilename}`;
    }
  }

  if (typeof hostImageFilename === 'string' && hostImageFilename.trim()) {
    return getHostImageSrc(hostImageFilename);
  }

  return DEFAULT_HOST_IMAGE;
}

export default getGamePackImageSrc;
